import { BarChart, Box, Button, Flex, Loading, Text, useAppTheme } from 'ui'
import { useMemo } from 'react'
import { useRatingsTimeseries } from 'queries/pulse/useRatingsTimeseries'
import { usePulseContext } from '../../context/PulseProvider'
import { useRatingsTimeseriesDownloadCsv } from 'queries/pulse/useRatingsTimeseriesDownloadCsv'
import { formatTimePeriodDate } from 'pages/PulsePage/utils'

export function RatingsTimeseries() {
  const { colors } = useAppTheme()
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useRatingsTimeseries(filters)

  const { mutateAsync: downloadCsv, isPending: isDownloadingCsv } =
    useRatingsTimeseriesDownloadCsv(filters)

  const chartData = useMemo(() => {
    return (data ?? []).map((item) => ({
      shift_date: formatTimePeriodDate(filters.timePeriod, item.shift_date),
      worker_rating: item.avg_worker_rating_by_shift,
      manager_rating: item.avg_shift_rating_by_worker,
    }))
  }, [data])

  const chartSeries = useMemo(() => {
    return [
      {
        name: 'worker_rating',
        label: 'Worker Rating',
        color: '#3B82F6',
        labelColor: colors.neutrals[400],
        yAxisId: 'left',
      },
      {
        name: 'manager_rating',
        label: 'Shift Rating',
        color: '#10B981',
        labelColor: colors.neutrals[400],
        yAxisId: 'left',
      },
    ]
  }, [])

  return (
    <Box>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap={3}
        mb={3}
      >
        <Box>
          <Text fontSize={3} fontWeight="500">
            Worker & Shift Ratings
          </Text>
          <Text fontSize={2} color="lightText">
            Evolution of Shift and Worker rating averages for the dates picked
            and position type selected
          </Text>
        </Box>
        <Button
          variant="secondary"
          onClick={() => downloadCsv()}
          loading={isDownloadingCsv}
        >
          CSV
        </Button>
      </Flex>
      {isLoading ? (
        <Box p={3}>
          <Loading />
        </Box>
      ) : (
        <BarChart
          data={chartData}
          dataKey="shift_date"
          height={450}
          series={chartSeries}
          valueFormatter={(value) => `${value.toFixed(2)}`}
          withTooltip
          withLegend
          withPointLabels
          withXAxis
          withYAxis
          yAxisProps={{
            domain: [0, 5],
            ticks: [0, 1, 2, 3, 4, 5],
          }}
        />
      )}
    </Box>
  )
}
